import { Box, Button, Popover, useMediaQuery } from "native-base";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";

const PopOverModal = ({
  svg,
  header = "",
  body = "",
  footer = "",
  button = false,
  isOpen = false,
  onClose = () => {},
  onOpenPress = () => {},
  height = "auto",
  type = "",
  maxHeight = "",
  boxShadow = "0px 5px 15px 0px rgba(0, 0, 0, 0.20)"
}) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  return (
    <Box
      alignItems={!MobileWindow && "center"}
      // px={MobileWindow && 4}
      // pb={MobileWindow && 5}
    >
      <Popover
        isOpen={isOpen}
        onClose={onClose}
        trigger={(triggerProps) => {
          return (
            <Button
              {...triggerProps}
              colorScheme="none"
              bgColor={button && COLORS.THEME_COLOR}
              textColor={button && COLORS.WHITE_COLOR}
              fontSize={button && COMMONFONTSIZE.MEDIUM_FONT_SIZE}
              fontWeight={button && COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              width={button && "100%"}
              px={type === "comments" ? 0 : undefined}
              py={(button || type === "three-dots") && "10px"}
              borderRadius={button && "100px"}
              onPress={onOpenPress}
            >
              {svg}
            </Button>
          );
        }}
      >
        <Popover.Content
          accessibilityLabel="Delete Customerd"
          w={header === "" ? "s" : "sm"}
          borderRadius={"8px"}
          style={{
            boxShadow: boxShadow,
            marginTop: button ? "8px" : "8px",
            marginRight: "15px",
          }}
        >
          {header && (
            <Popover.Header px={5} borderBottomWidth={"0"}>
              {header}
            </Popover.Header>
          )}
          {body && (
            <Popover.Body
              overflowY={maxHeight && "auto"}
              maxHeight={maxHeight}
              height={height}
              px={type === "notify" ? 0 : 5}
              style={{ boxShadow: "none" }}
            >
              {body}
            </Popover.Body>
          )}
          {footer && (
            <Popover.Footer
              justifyContent="center"
              px={5}
              borderTopWidth={(footer === "" || type === "notify") && "0"}
              style={{
                boxShadow: type === "notify" && "0",
              }}
              pt={type === "notify" && 0}
              pb={type === "notify" && "30px"}
            >
              {footer}
            </Popover.Footer>
          )}
        </Popover.Content>
      </Popover>
    </Box>
  );
};

export default PopOverModal;
